// @flow
import React from 'react';
import { Button, ButtonGroup, Icon } from '@shopify/polaris';
import { MobileAcceptMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { MobileCancelMajor } from '@shopify/polaris-icons';

import BannerOffer from './banner-offer';
import CustomModal from 'src/components/views/common/custom-modal';

import { routes } from 'src/routes';
import history from 'src/routes/history';
import { turboCampaignEnd } from 'src/helpers/whitelist';
import { URL } from 'src/constants/links';

type Props = {
  active: boolean,
  isHideUpgradeTurbo: boolean,
  onCancel: () => void
};

export const KEY_BOOST_TURBO_MODAL = 'already-close-modal-boost-turbo';

type ComposedProps = Props & WithI18nProps;

const FormerModal: React.FC<ComposedProps> = ({ i18n, isHideUpgradeTurbo, active, onCancel }) => {
  const handleOpenGuide = () => {
    window.open(URL['HowToSetupTurboTheme'], '_blank');
  };

  const handleUpgradeTurbo = () => {
    onCancel();
    history.push(routes.appPreferences.view());
  };

  return (
    <CustomModal
      id="modal-turbo"
      open={active}
      className="custom-modal custom-modal--turbo-campaign"
      clickBackdrop={onCancel}>
      <div className="Polaris-Modal-Header">
        <div className="Polaris-Modal-Header__Title">
          <h2 className="Polaris-DisplayText Polaris-DisplayText--sizeSmall">
            {i18n.translate('AdminHTML.Common.WarningFormer.Modal.title')}
          </h2>
        </div>
        <button className="Polaris-Modal-CloseButton" onClick={onCancel}>
          <Icon source={MobileCancelMajor} color="subdued" />
        </button>
      </div>

      <div className="modal-former-upgrade-turbo">
        <BannerOffer />

        <div>
          <p style={{ fontWeight: 600 }}>
            {i18n.translate('AdminHTML.Common.WarningFormer.Modal.note1')}
          </p>
          <p>{i18n.translate('AdminHTML.Common.WarningFormer.Modal.note2')}</p>
        </div>

        <div className="why-turbo-box">
          <p style={{ fontWeight: 600, fontSize: '16px', marginBottom: '8px' }}>
            {i18n.translate('AdminHTML.Common.WarningFormer.Modal.whyTurbo')}
          </p>

          <ul className="why-turbo__list">
            <li className="why-turbo__item">
              <Icon source={MobileAcceptMajor} />
              <p>
                {i18n.translate('AdminHTML.Common.WarningFormer.Modal.whyTurbo_Desc1', {
                  t: (
                    <b>{i18n.translate('AdminHTML.Common.WarningFormer.Modal.whyTurbo_Desc1_t')}</b>
                  )
                })}
              </p>
            </li>
            <li className="why-turbo__item">
              <Icon source={MobileAcceptMajor} />
              <p>
                {i18n.translate('AdminHTML.Common.WarningFormer.Modal.whyTurbo_Desc2', {
                  t: (
                    <b>{i18n.translate('AdminHTML.Common.WarningFormer.Modal.whyTurbo_Desc2_t')}</b>
                  )
                })}
              </p>
            </li>
            <li className="why-turbo__item">
              <Icon source={MobileAcceptMajor} />
              <p>
                {i18n.translate('AdminHTML.Common.WarningFormer.Modal.whyTurbo_Desc3', {
                  t: (
                    <b>{i18n.translate('AdminHTML.Common.WarningFormer.Modal.whyTurbo_Desc3_t')}</b>
                  )
                })}
              </p>
            </li>
          </ul>
        </div>

        <div className="how-to-upgrade-box">
          <p style={{ fontWeight: 600, fontSize: '16px', marginBottom: '8px' }}>
            {i18n.translate('AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo')}
          </p>

          <ol className="how-to-upgrade__list">
            <li className="how-to-upgrade__item">
              <p>
                {i18n.translate('AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc1', {
                  t1: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc1_t1'
                      )}
                    </b>
                  ),
                  t2: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc1_t2'
                      )}
                    </b>
                  )
                })}
              </p>
            </li>
            <li className="how-to-upgrade__item">
              <p>
                {i18n.translate('AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc2', {
                  t1: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc2_t1'
                      )}
                    </b>
                  ),
                  t2: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc2_t2'
                      )}
                    </b>
                  )
                })}
              </p>
            </li>
            <li className="how-to-upgrade__item">
              <p>
                {i18n.translate('AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc3', {
                  t1: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc3_t1'
                      )}
                    </b>
                  ),
                  t2: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc3_t2'
                      )}
                    </b>
                  )
                })}
              </p>
            </li>
            <li className="how-to-upgrade__item">
              <p>
                {i18n.translate('AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc4', {
                  t: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc4_t'
                      )}
                    </b>
                  )
                })}
              </p>
            </li>

            <li className="how-to-upgrade__item">
              <p>
                {i18n.translate('AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc5', {
                  date: <b>{turboCampaignEnd.format('MMM D')}</b>,
                  t: (
                    <b>
                      {i18n.translate(
                        'AdminHTML.Common.WarningFormer.Modal.howToUpgradeTurbo_Desc5_t'
                      )}
                    </b>
                  )
                })}
              </p>
            </li>
          </ol>
        </div>
      </div>

      <div className="Polaris-Modal-Footer">
        <ButtonGroup>
          <Button onClick={handleOpenGuide} accessibilityLabel="View guide">
            {i18n.translate('AdminHTML.Common.WarningFormer.Modal.viewGuide')}
          </Button>
          {!isHideUpgradeTurbo && (
            <Button primary onClick={handleUpgradeTurbo} accessibilityLabel="Upgrade to Turbo">
              {i18n.translate('AdminHTML.Common.WarningFormer.Modal.upgradeToTurbo')}
            </Button>
          )}
        </ButtonGroup>
      </div>
    </CustomModal>
  );
};

export default withI18n()(FormerModal);
